import $ from 'jquery';
import cptFilters from "../cpt-filters/script";

const loadMore = {
    settings: {
        button: document.querySelector('.js-load-more'),
        args: {
            taxonomy: '',
            taxonomyTerm: '',
            postType: '',
            postsPerPage: '',
            currentPage: '',
            buttonId: '',
            searchFor: ''
        },
    },

    init() {
        if (!this.settings.button) return;

        this.bindEvents();
    },

    bindEvents() {
        const postListing = this.settings.button.closest('.post-listing');
        const postListingContainer = postListing.querySelector('.post-listing__posts');

        this.settings.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.getDataFromButton(this.settings.button);
            console.log(this.settings.args)
            this.loadMorePosts(this.settings.button, postListingContainer);
        })
    },

    getDataFromButton(button) {
        const args = {};
        const data = button.dataset;

        Object.entries(data).forEach(([key, value]) => {
            args[key] = value;
        });

        this.settings.args = this.filterAllowedArgs(args);
    },

    filterAllowedArgs(args) {
        const allowedKeys = Object.keys(this.settings.args);
        return Object.fromEntries(
            Object.entries(args).filter(([key]) => allowedKeys.includes(key))
        );
    },

    loadMorePosts(button, container, filter = false) {
        const args = this.settings.args;
        if (!args || !container) return;

        args.action = 'load_more_cpt';
        args.nonce = cptListingAjax.nonce;

        if (filter) {
            args.filter = filter
        }

        $.ajax({
            url: cptListingAjax.ajax_url,
            type: 'POST',
            data: args,

            beforeSend: () => {
                button.classList.add('button-loading');
                container.classList.add('posts-loading');
            },
            success: (response) => {
                if (response?.success && response.data.items.length) {
                    const posts = response.data.items;

                    posts.forEach(htmlString => {
                        const temp = document.createElement('div');
                        temp.innerHTML = htmlString.trim(); // wrap the string to create DOM nodes
                        const element = temp.firstElementChild;
                        if (element) container.appendChild(element);
                    });

                    button.dataset.currentPage = response.data.meta.currentPage;
                    button.dataset.taxonomy = button.dataset.taxonomy ?? this.settings.args.taxonomy;
                    button.dataset.taxonomyTerm = button.dataset.taxonomyTerm ?? this.settings.args.taxonomyTerm;
                    button.dataset.searchFor = button.dataset.searchFor ?? this.settings.args.searchFor;

                    if (response.data.meta.isLastPage) {
                        button.setAttribute('disabled', 'disabled');
                    } else {
                        button.removeAttribute('disabled');
                    }

                } else {
                    button.setAttribute('disabled', 'disabled');
                    console.log('No more posts to load');
                }
            },
            complete: () => {
                button.classList.remove('button-loading');
                container.classList.remove('posts-loading');
                loadMore.getDataFromButton(button);
            }
        });
    },
}
export default loadMore;

window.addEventListener('DOMContentLoaded', () => loadMore.init());